import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ptBR from "./locales/pt-BR.json";

const i18nPayfac = i18n.createInstance();

i18nPayfac.use(initReactI18next).init({
  resources: {
    "pt-BR": { translation: ptBR },
  },
  lng: localStorage.getItem("i18nextLng") || "pt-BR",
  fallbackLng: "pt-BR",
  interpolation: {
    escapeValue: false,
  },
});

export default i18nPayfac;
